import {useState} from 'react';
import {getDayStart, getDayEnd} from '../libs/dateLib.js';
import moment from 'moment';

export default function useDateInterval(props) {

  const sm = moment();
  const em = moment();

  const startDate = props?.startDate
    || (sm.date() < 25
    ? sm.subtract(1, 'months').date(25)
    : sm.date(25));
  const endDate = props?.endDate
    || em.endOf('day');

  const [start, _setStart] = useState(getDayStart(startDate));
  const setStart = date => _setStart(getDayStart(date));

  const [end, _setEnd] = useState(getDayEnd(endDate));
  const setEnd = date => _setEnd(getDayEnd(date));

  return [start, setStart, end, setEnd];
}
